<template>
	<div class="one-row colored-background">
		<!-- Pop up form -->
		<popup-form v-if="showPopUpForm" :value="changeValue" :type="changeType" @closePopUp="closeChangeForm"></popup-form>

		<!-- Go to HUB page box -->
		<div class="modal-box-row">
			<div class="box modal-box" :class="$parent.tvPlatform ? 'tv-platfrom' : ''">
        <div class="image-container">
          <img class="banner-image" src="../assets/images/multi-device-lp.png" alt="Kidjo Products" :class="$parent.tvPlatform ? 'tv-platfrom' : ''">
        </div>
        <SubmitButton class="set-button-width" :label="$t('profile_page_modal_box_link')" :isLoading="false" @click="routeToProducts()"/>
			</div>
		</div>

		<!-- Profile Info Box -->
		<div class="box profie-box" :class="$parent.tvPlatform ? 'tv-platfrom' : ''">
			<span class="box-title">{{ $t('profile_page_box_title') }}</span>
			<span class="profile-box-subtitle">{{ $t('profile_page_box_subtitle') }}</span>
      
			<div class="box-card" :class="$i18n.locale === 'ar' ? 'arabic-text' : ''">
        <div class="box-card-separator"></div>
				<!-- Base information -->
				<ul class="box-card-details">
					<li class="box-card-detail">
						<span class="primary" :class="$i18n.locale === 'ar' ? 'arabic-text-right' : ''">{{ $t('email') }}:</span> <span class="secondary" :class="$i18n.locale === 'ar' ? 'align-text-left' : ''">{{ this.accountDetails.email }}</span>
					</li>
					<li class="box-card-detail box-card-sub-detail" >
						<a href="#" :class="$i18n.locale === 'ar' ? 'align-text-left' : ''" @click.prevent="showChangeForm('email')">{{ $t('profile_page_change_email_button') }}</a>
					</li>
					<li class="box-card-detail">
						<span class="primary" :class="$i18n.locale === 'ar' ? 'arabic-text-right' : ''">{{ $t('password') }}:</span> <span class="secondary" :class="$i18n.locale === 'ar' ? 'align-text-left' : ''">*******</span>
					</li>
					<li class="box-card-detail box-card-sub-detail" :class="$i18n.locale === 'ar' ? 'align-text-left' : ''">
						<router-link :class="$i18n.locale === 'ar' ? 'align-text-left' : ''" to="/change-password">{{ $t('profile_page_change_password_link') }}</router-link>
					</li>
				</ul>

				<!-- Subscription info -->
				<span v-if="!subscription_has_error && accountDetails.subscriptions.length > 0" >
					<ul class="box-card-details" v-for="(subscription, index) in this.accountDetails.subscriptions" :key="index">

						<div class="box-card-separator"></div>

						<!-- Coupon details -->
						<template v-if="subscription.coupon != null">
							<li class="box-card-detail" v-if="subscription.coupon.couponSerialNumber">
								<span class="primary" :class="$i18n.locale === 'ar' ? 'arabic-text-right' : ''">{{ $t('profile_page_promo_code') }}:</span>
								<span class="secondary" :class="$i18n.locale === 'ar' ? 'align-text-left' : ''">
									{{ subscription.coupon.couponSerialNumber }} - {{ promoMessage(subscription) }}
								</span>
							</li>

							<template v-if="subscription.coupon.couponType === 'FREE_ACCESS_COUPON'|| subscription.coupon.couponType === 'UNIQUE_ACCESS_COUPON'">
								<li class="box-card-detail">
									<span class="primary" :class="$i18n.locale === 'ar' ? 'arabic-text-right' : ''">
										{{ $t('profile_page_active_until') }}:
									</span>
									<span class="secondary" :class="$i18n.locale === 'ar' ? 'align-text-left' : ''">{{ subscription.nextBillingDate | formatDate }}</span>
								</li>

								<li class="box-card-detail" v-if="subscription.coupon.couponSerialNumber === 'ACEF25'">
									<span class="primary" :class="$i18n.locale === 'ar' ? 'arabic-text-right' : ''">{{ $t('profile_page_payment_method') }}:</span> <span class="secondary" :class="$i18n.locale === 'ar' ? 'align-text-left' : ''">ACEF accès par adhésion</span>
								</li>
                <li class="box-card-detail" v-else>
									<span class="primary" :class="$i18n.locale === 'ar' ? 'arabic-text-right' : ''" >{{ $t('profile_page_payment_method') }}:</span> <span class="secondary" :class="$i18n.locale === 'ar' ? 'align-text-left' : ''">Free access by coupon</span>
								</li>
							</template>
						</template>

						<!-- Next Invoice / show only if the subscription is from brantree -->
						<li class="box-card-detail" v-if="subscription.storeId === 'kidjo'">
							<span class="primary" :class="$i18n.locale === 'ar' ? 'arabic-text-right' : ''">
								{{ (subscription.isRenewing ? $t('profile_page_next_invoice') : $t('profile_page_active_until')) }}:
							</span>
							<span class="secondary" :class="$i18n.locale === 'ar' ? 'align-text-left' : ''">{{ subscription.nextBillingDate | formatDate }}</span>
						</li>

            <!-- logicom on time promotion paymenth method -->
						<li class="box-card-detail"
                v-if="subscription.storeId === 'playstore' && subscription.paymentStateId === 'Free_Campaign'">
							<span class="primary" :class="$i18n.locale === 'ar' ? 'arabic-text-right' : ''">{{ $t('profile_page_payment_method') }}:</span> <span
                class="secondary" :class="$i18n.locale === 'ar' ? 'align-text-left' : ''">Logicom</span>
						</li>

            <!-- Paymenth method details -->
             
            <li class="box-card-detail"
                v-if="subscription.storeId === 'mondia' && subscription.isRenewing">
							<span class="primary" :class="$i18n.locale === 'ar' ? 'arabic-text-right' : ''">{{ $t('profile_page_payment_method') }}:</span> <span
                class="secondary" :class="$i18n.locale === 'ar' ? 'align-text-left' : ''">{{ getPaymentMethod(subscription.paymentMethod, subscription.storeId) }}</span>
						</li>
						<li class="box-card-detail" v-else-if="subscription.isRenewing">
							<span class="primary" :class="$i18n.locale === 'ar' ? 'arabic-text-right' : ''">{{ $t('profile_page_payment_method') }}:</span> <span
                class="secondary" :class="$i18n.locale === 'ar' ? 'align-text-left' : ''">{{ getPaymentMethod(subscription.paymentMethod, subscription.storeId) }}</span>
						</li>

            <!-- Paymenth Plan details -->
						<li class="box-card-detail">
							<span class="primary" :class="$i18n.locale === 'ar' ? 'arabic-text-right' : ''">{{ $t('profile_page_plan') }}:</span> <span class="secondary" :class="$i18n.locale === 'ar' ? 'align-text-left' : ''">{{
                getPlanName(subscription.paymentPlanId, subscription.subscriptionType, subscription.storeId, subscription.durationCode)
              }}</span>
						</li>

            <!--Change Plan-->
            <li :class="$i18n.locale === 'ar' ? 'align-text-left' : ''" class="box-card-detail" v-if="$parent.tvPlatform === false && subscription.storeId ==='kidjo' && subscription.storeId !== 'salt'">
							<router-link
                  to="/changeSubscriptionPlan"
                  v-if="subscription.isRenewing">
									{{ $t('profile_page_change_plan_link') }}
							</router-link>
						</li>
            <!-- Unsubscribe link -->
						<li class="box-card-detail"
                v-if="subscription.isRenewing && subscription.paymentStateId !== 'Free_Campaign' && $parent.tvPlatform === false && subscription.storeId !== 'salt'">
							<a @click="unsubscribe(subscription)">{{ $t('profile_page_unsubscribe_link') }}</a>
						</li> 

            <!-- Resubscribe link / only for subscriptions from brain tree -->
						<li class="box-card-detail" v-if="$parent.tvPlatform === false && subscription.storeId ==='kidjo' && !subscription.isRenewing && subscription.paymentStateId !== 'Free_Campaign' && subscription.storeId !== 'salt'">
                <SubmitButton class="set-button-width" :label="$t('profile_page_resubscribe_button')" :isLoading="false" @click="routeToChangePlan()"/>
              
						</li>
					</ul>
				</span>

      </div>
    </div>
  </div>
</template>
<script>
import PaymentPlansService from '../services/paymenth.plans.service';
import popUpForm from '../components/popUpForm.vue';
import SubmitButton from '../components/SubmitButton.vue';

export default {
  components: {
			"SubmitButton": SubmitButton,
      'popup-form': popUpForm
    },
  data() {
    return {
      subscription_has_error: false,
      showPopUpForm: false,
      changeValue: ""
    };
  },
  filters: {
    formatDate(value) {
      return new Date(value).toLocaleDateString();
    },
  },
  computed: {
    accountDetails() {
      return this.$store.getters['getAccountDetails'];
    },
    isSubscriptionExpired(nextBillingDate) {
      const nextBillDate = new Date(nextBillingDate);
      const today = Date();
      return nextBillDate <= today;
    }
  },
  methods: {
    routeToChangePlan: function() {
      this.$router.replace({path: '/changeSubscriptionPlan'})
    },
    routeToProducts: function() {
      this.$router.replace({path: '/products'})
    },
    getPlanName: function (id, type, store, durationCode) {
      return PaymentPlansService.searchPlanByType(type);
    },

    getPaymentMethod: function (paymentMethod, storeId) {
      if (storeId === 'kidjo') {
        if (paymentMethod === "free") {
          return this.$t('free_trial');
        }
        return paymentMethod;
      }

      if (storeId === 'swisscom') {
        return 'Swisscom';
      }

      if (storeId === 'ios') {
        return this.$t('profile_page_payment_method_apple');
      }

      if (storeId === 'playstore') {
        return this.$t('profile_page_payment_method_play_store');
      }

      if (storeId === 'documo') {
        return this.$t('profile_page_payment_method_docomo');
      }

      if (storeId === 'samsung') {
        return this.$t('profile_page_payment_method_samsung');
      }

      
      if (storeId === 'mondia') {
        return (paymentMethod.split(' ')[0] + ' ' +  this.$t('mobile_subscription'));
      }

      return '';
    },

    resubscribe: function () {
      this.$store.dispatch("removePremium");
      this.$router.push({name: 'subscribe'}).catch(() => {
      });
    },
    unSubscribeSwitch: function (id, storeId) {
      localStorage.setItem('storeId', 'switch');
      return this.$router.push('/unsubscribe/?id=' + id +'&type=' + storeId );
    },
    unsubscribe: function (subscription) {
      const docomoUrls = {
        ['movistar']: "https://emocion.movistar.es/micuenta",
        ['orange']: 'http://webappsupport.fr/selfCare/login',
        ['default']: "https://support.kidjo.tv/hc/fr/articles/25305202155025-Comment-résilier-mon-abonnement-Kidjo"
      };
      const redirectToUrl = (url) => window.location.replace(url);
      const actionMap = {
        ['virgo']: () => { redirectToUrl("https://support.kidjo.tv/hc/fr/articles/25305202155025-Comment-résilier-mon-abonnement-Kidjo"); },
        ['switch']: () => this.unSubscribeSwitch(subscription.id, subscription.storeId),
        ['kidjo']: () => { this.$router.push({ path: '/unsubscribe/' + subscription.id }); },
        ['swisscom']: () => { this.$router.push({ path: '/unsubscribe', query: { type: 'swisscom' } }); },
        ['ios']: () => { redirectToUrl("https://support.apple.com/HT202039"); },
        ['playstore']: () => { redirectToUrl("https://support.google.com/googleplay/answer/7018481"); },  
        ['docomo']: () => { redirectToUrl(docomoUrls[subscription.platformPurchadeId] || docomoUrls['default']); },
        ['default']: () => { redirectToUrl("https://support.kidjo.tv/hc/en-001/articles/25305202155025-How-can-I-cancel-my-Kidjo-subscription"); }
      }
      const action = actionMap[subscription.storeId] || actionMap['default'];
      return action();
    },
    getCouponDuration: function (subscription) {
      const duration_period = {
        day: this.$t('label_day'),
        days: this.$t('label_days'),
        month: this.$t('month'),
        year: this.$t('year'),
        months: this.$t('label_months'),
      };
      const value = subscription.coupon.couponDurationCode; // e.g. "P1Y"
      const duration = parseInt(value.replace(/\D/g, ''), 10) || 0; // extract number
      let suffix = '';

      if (value.includes('Y')) {
        suffix = 'year';
      } else if (value.includes('M')) {
        suffix = 'month';
      } else if (value.includes('D')) {
        suffix = 'day';
      } else {
        suffix = 'month'; // default fallback
      }

      if (duration > 1) {
        suffix += 's'; // pluralize
      }

      return {
        duration,
        durationPeriods: duration_period[suffix], // plural
        durationPeriod: duration_period[suffix.replace(/s$/, '')] // singular
      };
    },
    promoMessage: function (subscription) {
        const {duration,durationPeriod,durationPeriods}=this.getCouponDuration(subscription)
        return `${duration} ${durationPeriods}`
    },
    showChangeForm: function (type) {
      this.changeType = type;
      if (type === 'email') {
        this.changeValue = this.$store.state.legacy.email;
      } else {
        this.changeValue = this.$store.state.legacy.name;
      }
      this.showPopUpForm = true;
    },

    closeChangeForm: function () {
      this.changeValue = "";
      this.showPopUpForm = false;
    }
  },

  mounted: async function () {
    localStorage.removeItem('app')
    if (this.$store.getters.getToken === false && this.$route.path !== '/homePage') {
      return this.$router.replace('/homePage');
    }

    this.$parent.loading = true;
    const routeFrom = this.$route.query.from === 'unsubscribe'
    if (routeFrom && localStorage.getItem('storeId') === 'switch') {
      localStorage.removeItem('storeId')
      this.$router.push({name: 'subscribe'}).catch(() => {
      });
    } else {
        await this.$store.dispatch('checkUserSubscriptions').then(() => {
          this.$parent.hasPremium = true;
        }).catch((error) => {
            this.subscription_has_error = true;
            if (error.status === 404) {
              this.$parent.showFlashMessage(this.$t('profile_page_error_finding_subscription'));
            }
            if (error.status === 400) {
              this.$parent.showFlashMessage(this.$t('error_message_something_went_wrong'));
            }
              this.$router.push({name: 'subscribe'}).catch(() => {
            });
        });
    }

    if (this.$parent.appStyle === 'subscribe') {
      this.$parent.changeAppStyle('profile');
    }

    // This is needed if the user scrolls down during page load and you want to make sure the page is scrolled to the top once it's fully loaded. This has Cross-browser support.
    window.scrollTo(0, 0);
    this.$parent.loading = false;
  },
}
</script>
<style scoped >
.align-text-left {
  text-align: left !important;
}
.arabic-text-right {
  text-align: right !important;
}
</style>